import { Link, useLocation } from "react-router-dom";
import { Eye } from "lucide-react";
import { cn } from "./ui";

// Only pages that have a /preview route; the others were dead links (404)
const pages = [
  { path: "/preview", label: "Overview" },
  { path: "/preview/create-listing", label: "Create listing" },
  { path: "/preview/listing-detail", label: "Listing detail" },
];

export default function PreviewNav() {
  const { pathname } = useLocation();
  const current = pathname.replace(/\/+$/, "") || "/";

  return (
    <nav aria-label="Preview pages" className="border-b border-gray-800 bg-gray-950 text-white">
      <div className="scrollbar-none flex items-center gap-3 overflow-x-auto px-4 py-2 sm:px-6">
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-white/10 px-2.5 py-1 text-xs font-semibold tracking-[0.08em] text-white/80">
          <Eye aria-hidden className="size-3.5" />
          Preview
        </span>
        <div className="flex shrink-0 items-center gap-1">
          {pages.map((page) => {
            const active = current === page.path;
            return (
              <Link
                key={page.path}
                to={page.path}
                aria-current={active ? "page" : undefined}
                className={cn(
                  "rounded-md px-2.5 py-1 text-meta font-medium transition-colors",
                  active ? "bg-white text-gray-900" : "text-white/70 hover:bg-white/10 hover:text-white"
                )}
              >
                {page.label}
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
